import React from 'react';
import classNames from 'classnames';

import DayPickerInput from 'react-day-picker/DayPickerInput';

import {formatDate, parseDate} from 'react-day-picker/moment';

import {DATE_FORMAT} from 'utils/datetime';

import 'react-day-picker/lib/style.css';
import './styles.css';

export const TopLeftFixedCustomOverlay = ({
  children,
  onBlur,
  onFocus,
  tabIndex,
  input
}: any) => {
  // Custom Overlay will be fixed to top left from input
  const position = input.parentElement.getBoundingClientRect();

  return (
    <div
      className="TopLeftFixedCustomOverlay"
      onBlur={onBlur}
      onFocus={onFocus}
      tabIndex={tabIndex}
      style={{left: position.left, top: position.top}}>
      <div className="OverlayWrapper">{children}</div>
    </div>
  );
};

export const BottomLeftFixedCustomOverlay = ({
  children,
  onBlur,
  onFocus,
  tabIndex,
  input
}: any) => {
  // Custom Overlay will be fixed to bottom left from input

  const position = input.parentElement.getBoundingClientRect();
  return (
    <div
      className="BottomLeftFixedCustomOverlay"
      onBlur={onBlur}
      onFocus={onFocus}
      tabIndex={tabIndex}
      style={{left: position.left, top: position.top + position.height}}>
      <div className="OverlayWrapper">{children}</div>
    </div>
  );
};

export const BottomRightCustomOverlay = ({
  children,
  onBlur,
  onFocus,
  tabIndex
}: any) => {
  // Custom Overlay will be fixed to bottom right from input

  return (
    <div
      className="BottomRightCustomOverlay"
      onBlur={onBlur}
      onFocus={onFocus}
      tabIndex={tabIndex}>
      <div className="OverlayWrapper">{children}</div>
    </div>
  );
};

class DatePicker extends React.Component<any> {
  render() {
    const {
      className,
      placeholder,
      disabled,
      dayPickerProps,
      onChange,
      onBlur,
      value,
      // If we pass overlayComponent as undefined - the default overlay will be used
      overlayComponent = undefined
    } = this.props;

    const classNameProp = classNames(className, ' DatePicker', {
      disabled: disabled
    });

    return (
      <div className={classNameProp}>
        <DayPickerInput
          overlayComponent={overlayComponent}
          onDayChange={(_selectedDay, _modifiers, dayPickerInput: any) => {
            onChange(dayPickerInput.input.value);
          }}
          onDayPickerHide={onBlur}
          formatDate={formatDate}
          format={DATE_FORMAT}
          parseDate={parseDate}
          placeholder={placeholder || DATE_FORMAT}
          value={value}
          dayPickerProps={dayPickerProps}
        />
      </div>
    );
  }
}

export default DatePicker;
